module.exports = __webpack_public_path__ + "29ad9cfd0b1c49061cf1b8c18fcac6e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/youth-baby.jpg
// module id = 485
// module chunks = 0